
import React, { useState } from 'react';
import star from '../../asset/Star.png'

export const FloatingBookButton = () => {
  const [isHovered, setIsHovered] = useState(false);

  const scrollToBookATour = () => {
    const element = document.getElementById('book-a-tour');
    if (element) {
      const headerHeight = 105;
      const elementPosition = element.offsetTop - headerHeight;
      
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <button
      onClick={scrollToBookATour}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="fixed right-0 top-1/2 -translate-y-1/2 z-50 bg-gradient-to-r from-[#966376] via-[#CE92A8] to-[#cca1b181] text-white shadow-lg hover:shadow-xl transition-all duration-300 ease-in-out transform hover:scale-105 hidden sm:block"
      style={{
        borderRadius:'50px 0 0 50px',
        padding: isHovered ? '12px 24px' : '12px 16px',
        minWidth: isHovered ? '160px' : '80px',
        transition: 'all 0.3s ease-in-out',
      }}
    >
      <span className="flex items-center justify-center gap-2 font-medium text-sm whitespace-nowrap overflow-hidden">
        {isHovered ? (
          <span className="animate-fade-in flex items-center"><img className="h-[10px] w-[10px] mr-2" src={star} />Book A Tour</span>
        ) : (
          <span className="animate-fade-inflex flex items-center"><img className="h-[10px] w-[10px] mr-2" src={star} />Book</span>
        )}
      </span>
    </button>
  );
};
